import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

/**
 * LinkedIn import-dialog state + OAuth-return handling, extracted from
 * ServicePage so the `?linkedin=<marker>` wiring is unit-testable in isolation.
 *
 * On return from the BFF (`/save?linkedin=ok|error|denied|not_configured`) it
 * records the marker, opens the dialog in result mode, and strips the marker
 * (replace history) so a refresh / back-button doesn't re-trigger the dialog.
 * Opening fresh from the service card sets `open` true with `returnMarker` null.
 */
export function useLinkedinReturn(): {
  returnMarker: string | null;
  setReturnMarker: (marker: string | null) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
} {
  const [open, setOpen] = useState(false);
  const [returnMarker, setReturnMarker] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const marker = searchParams.get("linkedin");
    if (marker === null) return;
    setReturnMarker(marker);
    setOpen(true);
    const next = new URLSearchParams(searchParams);
    next.delete("linkedin");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return { returnMarker, setReturnMarker, open, setOpen };
}
